import {Component} from '@angular/core';
import {ModalRef} from 'src/app/ui-library/modal/modal-ref';

@Component({
    selector: 'app-contact-shared',
    templateUrl: './contact-shared.component.html',
    styleUrls: ['./contact-shared.component.css'],
    standalone: false
})
export class ContactSharedComponent {

    constructor(private modal: ModalRef) {
    }

    ok(): void {
        this.modal.close();
    }

}
